const BRAND_CURATION_TASK_INITIAL_STATE = {
  isLoading: false,
  isUpdateLoading: false,
  updateError: undefined,
  error: undefined,
  data: undefined,
}

export default BRAND_CURATION_TASK_INITIAL_STATE
